import React, { useState, useEffect, useMemo } from "react";
import { replaceOrigin } from "../util/helper";
import { useContext } from "react";
import { AuthContext } from "../common/Auth";
import { Buffer } from "buffer";

const ImageRetrieval = ({ className, logoHeight, logoWidth, footerlogoWidth, isHeader, isgotimage, setisgotimage }) => {
  const { images } = useContext(AuthContext);
  const memoizedImages = useMemo(() => images, [images]);
  const [lastImage, setLastImage] = useState(null);
  const retrieveImage = () => {
      if (images && images.length > 0 && !isgotimage) {
          let lastIndex = images[images.length - 1];
          let bufferedImage = "data:" + lastIndex.mimetype + ";base64," + Buffer.from(lastIndex.buffer.data).toString('base64');
          setLastImage(bufferedImage);
          setisgotimage(true)
      }
  }

  useEffect(() => {
    retrieveImage()
  }, [memoizedImages])

  let footerLogowidth = Number(footerlogoWidth) > 0 ? footerlogoWidth : ""
  let headerLogowidth = Number(logoWidth) > 0 ? logoWidth : ""

  if (isHeader) {
    return (
      <>
        {lastImage && (
          <figure style={{ maxWidth: headerLogowidth + "px" }} className="antera-logo-image pageLogo">
            <img
              alt=""
              src={replaceOrigin(lastImage)}
            />
          </figure>
        )}
      </>
    )
  } else {
    return (
      <>
        {lastImage && (
          <figure style={{ maxWidth: footerLogowidth + "px" }} className="antera-logo-image pageLogo">
            <img
              alt=""
              src={replaceOrigin(lastImage)}
            />
          </figure>
        )}
      </>
    )
  }
}
export default ImageRetrieval;
